import { cleanClientSummary } from 'js/components/client-summary';
import {
  executeAbortControllerRefs,
  rotateAbortControllerRef,
  isAbortError,
} from 'js/components/fetch';

export const onMountEffect = (options = {}) => {
  const { abortControllerRefs = [], setLoadingPrimaryClient } = options;
  return () => {
    // Abort requests on unmount:
    return () => {
      executeAbortControllerRefs(abortControllerRefs);
      setLoadingPrimaryClient(false);
    };
  };
};

export const getPrimaryClientEffect = (options = {}) => {
  const {
    t,
    api,
    id,
    setLoadingPrimaryClient,
    setPrimaryClient,
    getPrimaryClientAbortControllerRef,
  } = options;
  return async () => {
    setLoadingPrimaryClient(true);

    rotateAbortControllerRef(getPrimaryClientAbortControllerRef);
    const { signal } = getPrimaryClientAbortControllerRef.current;

    try {
      const { json = {} } = await api.getJson(
        `/Client/${id}/00`,
        { signal },
        {
          success: { bypass: true },
          error: {
            context: {
              message: t('components.ClientDependentOf.requestError'),
            },
          },
        }
      );

      setPrimaryClient(cleanClientSummary(json));
      setLoadingPrimaryClient(false);
    } catch (error) {
      if (!isAbortError(error)) {
        setLoadingPrimaryClient(false);
      }
    }
  };
};
